import React from 'react';

const CompletionPage = ({ onReturnToLanding, userInfo }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card rounded-2xl p-8 w-full max-w-lg text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/logos/DP LOGO - ON WHT.png" 
            alt="Dewpoint Group Logo" 
            className="h-16 w-auto"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

        {/* Success Icon */}
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Thank You Message */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold gradient-text mb-4">
            Assessment Complete!
          </h1>
          <p className="text-lg text-gray-700 mb-4">
            Thank you for your valuable time to complete the AI Maturity Assessment Questionnaire.
          </p>
          <p className="text-sm text-gray-600">
            Your responses have been successfully recorded and will contribute to your organization's AI maturity evaluation.
          </p>
        </div>

        {/* User Info */}
        {userInfo && (
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h3 className="font-medium text-gray-800 mb-2">Assessment Details:</h3>
            <div className="text-sm text-gray-600 space-y-1">
              <p><span className="font-medium">Employee:</span> {userInfo.employeeName}</p>
              <p><span className="font-medium">Company:</span> {userInfo.companyCode}</p>
              <p><span className="font-medium">Completed:</span> {new Date().toLocaleDateString()}</p>
            </div>
          </div>
        )}

        {/* Return Button */}
        <button
          onClick={onReturnToLanding}
          className="btn-primary w-full"
        >
          Return to Main Page
        </button>

        {/* Footer Message */}
        <div className="mt-6 text-xs text-gray-500">
          <p>Your assessment results will be processed and included in the overall analysis.</p>
        </div>
      </div>
    </div>
  );
};

export default CompletionPage;